import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Upload.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: m }));
a.displayName = "UploadIcon";
const s = a;
export {
  s as Upload,
  a as UploadIcon
};
